import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { GameRoomPopupObject } from '../../constants'
import { CAMP } from '../../configs/networkConfig'
import {
  showActivePopup,
  setLineupId,
  setLineupName,
} from '../../Component/Redux/slices'
import { useUser } from '../../UserContext'
import { getWallet } from '../../utils/networkUtils'
import WalletError from '../WalletError'

const useJoinPopupsTrigger = () => {
  const { user } = useUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { gameRoomDetails, roomStatus, hasJoined } = useSelector(
    (state) => state.gameRoom
  )
  const userWallet = user.wallets

  const selectedWalletAddress = getWallet(userWallet, gameRoomDetails?.network)

  const handleJoinAction = () => {
    if (user && user.token) {
      // If hasJoined, show already saved lineup popup
      if (hasJoined) {
        dispatch(showActivePopup(GameRoomPopupObject.HAS_JOINED))
        return
      }
      // If lineup exists, show already saved lineup popup
      if (gameRoomDetails?.lineup) {
        dispatch(setLineupId(gameRoomDetails.lineup.id))
        dispatch(setLineupName(gameRoomDetails.lineup.name))
        dispatch(showActivePopup(GameRoomPopupObject.ALREADY_SAVED_LINEUP))
        return
      }

      // If room is open for entry
      if (roomStatus === 'entryOpened') {
        const shouldShowQuestConnect =
          gameRoomDetails?.network === CAMP &&
          !user?.paraWallet &&
          !gameRoomDetails?.hasJoined &&
          roomStatus === 'entryOpened'

        if (shouldShowQuestConnect) {
          dispatch(showActivePopup(GameRoomPopupObject.ASK_QUESTING_WALLET))
          return
        }

        if (selectedWalletAddress) {
          dispatch(showActivePopup(GameRoomPopupObject.SHOW_GROUND))
          return
        } else {
          return <WalletError walletType={gameRoomDetails?.network} />
        }
      } else {
        dispatch(showActivePopup(GameRoomPopupObject.ROOM_STATUS))
      }
    } else {
      navigate('/sign-in', {
        state: {
          from: window.location.pathname,
        },
      })
    }
  }

  return handleJoinAction
}

export default useJoinPopupsTrigger
